import { CollapsibleSection } from "components/collapsibleSection";
import {
  IAttendantTemplateForm,
  IAttendantTemplateItem,
  ISimpleEventDetail,
} from "interfaces";
import { isEmpty } from "lodash";
import { useState } from "react";
import { DEFAULT_PAGE_SIZE } from "utills/constants";
import Pagination from "components/pagination";
import { Groups } from "../groups";
import { useTranslation } from "@refinedev/core";

interface TemplatesFormProps {
  attendantTemplateDetail: IAttendantTemplateForm;
  eventDetailData: ISimpleEventDetail;
}

export const Templates = ({
  attendantTemplateDetail,
  eventDetailData,
}: TemplatesFormProps) => {
  const { translate } = useTranslation();
  const [templatePageNumber, setTemplatePageNumber] = useState(1);

  const [openTemplateId, setOpenTemplateId] = useState<
    string | null | undefined
  >(null);

  const templatePaginationIndex = {
    start: (templatePageNumber - 1) * DEFAULT_PAGE_SIZE,
    end: templatePageNumber * DEFAULT_PAGE_SIZE - 1,
  };

  console.log(attendantTemplateDetail);

  return (
    <>
      <div className="box-container p-0">
        <div className="flex flex-col flex-wrap gap-y-3 border-b border-gray-200 py-4 px-4 sm:px-6 sm:flex-row sm:items-center sm:justify-between">
          <h3 className="flex-1 shrink-0 text-base font-semibold leading-6">
            {translate("eventSetup.step.participantTemplate")}
          </h3>
        </div>
      </div>
      <div>
        <div>
          <div className="grid sm:grid-cols-6 lg:gap-x-6">
            <div className="col-span-full">
              {(attendantTemplateDetail.templates ?? []).map(
                (field: IAttendantTemplateItem, index: number) =>
                  index >= templatePaginationIndex.start &&
                  index <= templatePaginationIndex.end ? ( // only show item in range
                    <div
                      className="border rounded-lg mb-4 sm:mb-6 border-gray-300"
                      key={field.id}
                    >
                      <CollapsibleSection
                        label={field.attendant_template_name}
                        customOpen={{
                          open: openTemplateId === field.id,
                          onClick: () =>
                            setOpenTemplateId((prevId) =>
                              prevId === field.id ? null : field.id
                            ),
                        }}
                        isAnimated={false}
                      >
                        <Groups
                          templateData={field}
                          eventDetailData={eventDetailData}
                        />
                      </CollapsibleSection>
                    </div>
                  ) : (
                    <></>
                  )
              )}
            </div>
          </div>
          <div className="text-center text-sm">
            {isEmpty(attendantTemplateDetail?.templates ?? []) ? <p>{translate("eventSetup.participantTemplate.noTemplate")}</p> : <></>}
          </div>
          {(attendantTemplateDetail?.templates ?? []).length > DEFAULT_PAGE_SIZE ? (
            <div className="col-span-full bg-white p-4 sm:p-6">
              <Pagination
                currentPage={templatePageNumber}
                totalPage={Math.ceil(attendantTemplateDetail?.templates.length / DEFAULT_PAGE_SIZE)}
                hideTotal
                total={{
                  totalItems: attendantTemplateDetail?.templates.length || 0,
                  total: 0,
                }}
                onChange={(page) => setTemplatePageNumber(page)}
              />
            </div>
          ) : <></>}
        </div>
      </div>
    </>
  );
};
